// /assets/cart-format-override.js

(function () {
  function patchCartFormat() {
    if (!window.Alpine || typeof Alpine.store !== 'function') {
      return;
    }

    let store;
    try {
      store = Alpine.store('cart');
    } catch (e) {
      return;
    }

    if (!store || typeof store.format !== 'function') {
      return;
    }

    // Avoid patching multiple times on the same store instance
    if (store.__formatPatched) {
      return;
    }

    const originalFormat = store.format.bind(store);

    store.format = function (amount) {
      // Call the original formatter first
      let result = originalFormat(amount);

      // If it returns a string like "$159.00", strip the ".00" at the end
      if (typeof result === 'string') {
        result = result.replace(/\.00\b/, '');
      }

      return result;
    };

    store.__formatPatched = true;
    console.log('cart.format patched');
  }

  // Try once immediately…
  patchCartFormat();
  // …and keep trying every second in case the store is redefined later
  setInterval(patchCartFormat, 1000);
})();